import React, { Component } from 'react'
import history from '../../../history';
import axios from 'axios'
import UserProfile from '../../UserProfile'
import { SketchPicker } from 'react-color';
import authHeader from '../../authentication/authHeader'
import AuthService from '../../authentication/AuthService'
import ReactTooltip from 'react-tooltip';
import SimpleReactValidator from 'simple-react-validator';
import ocsvalidators, { messages, errorMessageClassName } from '../../utils/ocsvalidators'
import { RequiredTitle } from '../../utils/Util'

class ServicesEdit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            codesetItemId: '',
            codesetId: '',
            oncosmartSystemId: '',
            name: '',
            resourceTypeId: '',
            displayOrder: '',
            activeStatus: 'Y',
            servicestypesList: '',
            description: '',
            oncosmartSystemIdOld: '',
            showError: false,
            errorMsg: '',
            backcolor: '#fff',
            serviceList: [],
            nameorg: '',
            createdBy: '',
        }
        this.setFocus = React.createRef();
        this.validator = new SimpleReactValidator({
            autoForceUpdate: this,
            className: errorMessageClassName,
            validators: ocsvalidators,
            messages: messages
        });
    }
    componentDidMount() {
        let codesetitemid = this.props.match.params
        let id = codesetitemid.codeitemid.replace(":", "")

        axios.get('/services/' + id, { headers: authHeader() })
            .then(response => {
                axios.get('/servicetypeslist', { headers: authHeader() })
                    .then(response1 => {
                        axios.get('/serviceslist', { headers: authHeader() })
                            .then(response2 => {
                                this.setState({
                                    serviceList: response2.data,
                                    servicestypesList: response1.data,
                                    codesetItemId: response.data.codesetItemId, codesetId: response.data.codesetId, oncosmartSystemId: response.data.oncosmartSystemId, oncosmartSystemIdOld: response.data.oncosmartSystemId, name: response.data.name, resourceTypeId: response.data.resourceTypeId,
                                    displayOrder: response.data.displayOrder, activeStatus: response.data.activeStatus, backcolor: response.data.backcolor == null ? this.state.backcolor : response.data.backcolor, description: response.data.description, nameorg: response.data.name,
                                    createdBy: response.data.createdBy,
                                });
                            })
                            .catch(function (error) {
                                console.log(error);
                                history.push('/Errorpage')
                            })
                    })
                    .catch(function (error) {
                        console.log(error);
                        history.push('/Errorpage')
                    })
            })
            .catch(function (error) {
                console.log(error);
                history.push('/Errorpage')
            })
        this.setFocus.current.focus();
    }

    addServicesEdit = (event) => {
        event.preventDefault();
        if (!this.validator.allValid()) {
            this.validator.showMessages();
            return;
        }

        let bobj = this.state.serviceList.find((o, i) => {
            if (o.name === this.state.name) {
                if (this.state.nameorg === this.state.name) {
                    return false;
                }
                return true; // stop searching
            } else {
                return false;
            }
        });

        if (!bobj) {
            if (this.state.oncosmartSystemIdOld == this.state.oncosmartSystemId) {
                axios.put('/services/' + this.state.codesetItemId, {
                    codesetItemId: this.state.codesetItemId, codesetId: this.state.codesetId, oncosmartSystemId: this.state.oncosmartSystemId, name: this.state.name, resourceTypeId: this.state.resourceTypeId,
                    description: this.state.description, displayOrder: this.state.displayOrder, activeStatus: this.state.activeStatus, deletedYN: 'N', createdBy: this.state.createdBy,
                    lastUpdatedBy: AuthService.getCurrentUserName(), backcolor: this.state.backcolor
                }, { headers: authHeader() })
                    .then(response => {
                        UserProfile.setPage("Services");
                        UserProfile.setHighlights([this.state.codesetItemId], 'success')
                        history.push('/standardcode');
                    })
                    .catch(function (error) {
                        console.log(error);
                        history.push('/Errorpage')
                    })
            }
            else {
                axios.get('/servicesforoncosmart/' + this.state.oncosmartSystemId, { headers: authHeader() })
                    .then(response => {
                        if (response.data.length > 0) {
                            this.setState({
                                showError: true,
                                errorMsg: 'OncoSmart System ID already exists'
                            });
                        }
                        else {
                            axios.put('/services/' + this.state.codesetItemId, {
                                codesetItemId: this.state.codesetItemId, codesetId: this.state.codesetId, oncosmartSystemId: this.state.oncosmartSystemId, name: this.state.name, resourceTypeId: this.state.resourceTypeId,
                                displayOrder: this.state.displayOrder, activeStatus: this.state.activeStatus, deletedYN: 'N', createdBy: this.state.createdBy,
                                lastUpdatedBy: AuthService.getCurrentUserName(), backcolor: this.state.backcolor
                            }, { headers: authHeader() })
                                .then(response => {
                                    UserProfile.setPage("Services");
                                    UserProfile.setHighlights([this.state.codesetItemId], 'success')
                                    history.push('/standardcode');
                                })
                                .catch(function (error) {
                                    console.log(error);
                                    history.push('/Errorpage')
                                })
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                        history.push('/Errorpage')
                    })
            }
        } else {
            this.setState({
                showError: this.state.name.length > 0 ? true : false,
                errorMsg: 'Name already exists'
            });
        }
    }
    cancelServicesEdit = (event) => {
        event.preventDefault();
        UserProfile.setPage("Services");
        UserProfile.setHighlights([this.state.codesetItemId], 'info')
        history.push('/standardcode');
    }
    handleChange = (event) => {
        const target = event.target;
        const field = target.name;
        const value = target.value

        this.setState({
            [field]: value
        });
    }

    handleChangeComplete = (color) => {
        this.setState({ backcolor: color.hex });
    };

    render() {
        return (
            <div className="container-fluid">
                <div className="section-title">
                    <h4>Edit Services</h4>
                </div>
                <RequiredTitle />
                <div style={{ display: (this.state.showError ? 'block' : 'none') }}>
                    <label style={{ color: 'red' }}>{this.state.errorMsg}</label>
                </div>
                <div className="section-title containerAdd">
                    <table className="table table-striped table-bordered table-sm">
                        <thead className="thead-dark">
                        </thead>
                        <tbody>
                            <tr>
                                <td className="col-auto">OncoSmart System ID<span className='text-danger ml-1'>*</span></td>
                                <td className="col-auto"><input type="text"
                                    name="oncosmartSystemId"
                                    value={this.state.oncosmartSystemId}
                                    onChange={this.handleChange}
                                    ref={this.setFocus}
                                    id="oncosmartSystemId" className="form-control col-lg-2" maxLength="6" />
                                    {this.validator.message('OncoSmart System ID', this.state.oncosmartSystemId, 'required|numeric|min:0,num|numeric|max:999999,num')}
                                </td>
                            </tr>
                            <tr>
                                <td className="col-auto">Name<span className='text-danger ml-1'>*</span></td>
                                <td className="col-auto"><input type="text"
                                    name="name"
                                    value={this.state.name}
                                    onChange={this.handleChange}
                                    id="name" className="form-control" placeholder="Service name" />
                                    {this.validator.message('Name', this.state.name, 'required')}
                                </td>
                            </tr>
                            <tr>
                                <td>Service Type<span className='text-danger ml-1'>*</span></td>
                                <td className="form-inline">
                                    <select className="form-control mr-sm-1" value={this.state.resourceTypeId} name="resourceTypeId" id="resourceTypeId" onChange={this.handleChange}>
                                        <option value="0">-- Select Service Type --</option>
                                        {this.state.servicestypesList.length > 0
                                            && this.state.servicestypesList.map((servicestype, i) => {
                                                return (
                                                    <option key={i} value={servicestype.codesetItemId}>{servicestype.name}</option>
                                                )
                                            })}
                                    </select>
                                    {this.validator.message('resourceTypeId', this.state.resourceTypeId, 'required|not_in:0')}
                                </td>
                            </tr>
                            <tr>
                                <td>Description<span className='text-danger ml-1'>*</span></td>
                                <td className="col-auto"><textarea className="form-control"
                                    name="description"
                                    value={this.state.description}
                                    onChange={this.handleChange}
                                    id="description" rows="3" placeholder="Service Description"></textarea>Maximum 200 characters
                                    {this.validator.message('Description', this.state.description, 'required|maxLength:200')}
                                </td>
                            </tr>
                            <tr>
                                <td>Display Order<span className='text-danger ml-1'>*</span></td>
                                <td><input type="text"
                                    name="displayOrder"
                                    value={this.state.displayOrder}
                                    onChange={this.handleChange}
                                    id="displayOrder" className="col-lg-2 form-control" pattern="[0-9]*" maxLength="3" />
                                    {this.validator.message('Display Order', this.state.displayOrder, 'required|numeric|min:0,num|numeric|max:99999,num')}
                                </td>
                            </tr>
                            <tr>
                                <td>Active?<span className='text-danger ml-1'>*</span></td>
                                <td className="form-inline">
                                    <div className="form-group mx-sm-1 mb-1">
                                        <input className="form-check-input" type="radio" name="activeStatus" id="yes" value="Y" checked={this.state.activeStatus === "Y"} onChange={this.handleChange} />
                                        <label className="form-check-label" htmlFor="yes">Yes</label>
                                    </div>

                                    <div className="form-group mx-sm-4 mb-1 mx-lg-3">
                                        <input className="form-check-input" type="radio" name="activeStatus" id="no" value="N" checked={this.state.activeStatus === "N"} onChange={this.handleChange} />
                                        <label className="form-check-label" htmlFor="no">No</label>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>Select Color<span className='text-danger ml-1'>*</span></td>
                                <td className="form-inline">
                                    <div className="form-group mx-sm-1 mb-1">
                                        <SketchPicker
                                            color={this.state.backcolor}
                                            onChangeComplete={this.handleChangeComplete}
                                        />
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td colSpan="2">
                                    <ReactTooltip />
                                    <button type="button" onClick={this.addServicesEdit} className="btn btn-primary" data-tip="Save">Save</button>&nbsp;
                                    <button type="button" onClick={this.cancelServicesEdit} className="btn btn-secondary" data-tip="Cancel">Cancel</button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        )
    }
}

export default ServicesEdit
